import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const isStarted = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.FETCH_ALL_BY_DEALER]: isStarted,
  [types.FETCH_ALL_BY_DEALER_SUCCESS]: isEnded,
  [types.FETCH_ALL_BY_DEALER_FAILURE]: isEnded,
});
